import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import { Info } from "lucide-react";
function LoginForm() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    pass: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState("");

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.username)) {
      newErrors.username = "Enter valid 10-digit mobile number";
    }
    if (!formData.pass.trim()) {
      newErrors.pass = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError(""); // Clear any previous error messages
    if (validateForm()) {
      setIsLoading(true);
      try {
        const result = await login(formData.username, formData.pass);

        if (result && result.success) {
          const userData = JSON.parse(localStorage.getItem("user"));
          if (!userData) {
            setLoginError("Login failed. User data not found.");
            setIsLoading(false);
            return;
          }

          if (userData.Approved === 0) {
            setLoginError(
              "Your account is not approved yet. Please contact admin."
            );
            setIsLoading(false);
            return;
          }

          // Clear form data on successful login
          setFormData({
            username: "",
            pass: "",
          });
          
          // Check if user is Admin and redirect accordingly
          if (userData.UserRole === "Admin") {
            // Admin users go to selection page
            navigate("/selection");
          } else {
            // Non-admin users go directly to game page
            navigate("/aattam");
          }
        } else {
          setLoginError(result?.error || "Invalid username or password.");
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Login failed:", error);
        setLoginError(
          error?.response?.data?.message ||
            "Server error. Please try again later."
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="bg-gradient-to-r from-green-400 to-blue-500 p-8 rounded-lg shadow-lg w-full max-w-md mx-auto">
      <div className="flex items-center mb-4">
        <button
          onClick={() => navigate("/")}
          className="text-white hover:text-gray-200 focus:outline-none mr-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
        </button>
        <h2 className="text-2xl font-bold text-white text-center flex-grow">
          Login
        </h2>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-white">Mobile No</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600 text-black bg-white"
          />
        </div>
        {errors.username && (
          <p className="text-yellow-200 text-sm mt-1">{errors.username}</p>
        )}
        <div>
          <label className="block text-white">Password</label>
          <input
            type="password"
            name="pass"
            value={formData.pass}
            onChange={handleChange}
            className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600 text-black bg-white"
          />
        </div>
        {errors.pass && (
          <p className="text-yellow-200 text-sm mt-1">{errors.pass}</p>
        )}
        <button
          type="submit"
          disabled={isLoading}
          className="w-full px-6 py-3 text-base md:text-lg font-semibold rounded-xl bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg transform hover:scale-105 transition-transform duration-200"
        >
          {isLoading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-900"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25 "
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </button>
        {loginError && (
          <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full ">
            <div className="relative flex w-full p-3 pr-12 text-sm text-white bg-red-500 rounded-md">
              <Info className="mr-2" />
              {loginError}
              <button
                onClick={() => setLoginError("")}
                className="flex items-center justify-center transition-all w-8 h-8 rounded-md text-white hover:bg-white/10 active:bg-white/10 absolute top-1.5 right-1.5"
                type="button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="h-5 w-5"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default LoginForm;
